import React from 'react';
import { CustomCellRendererProps } from 'ag-grid-react';
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { ServerDashboardJob } from '../../dashboardType';

export const convertTimeHumanReadable = (isoString: string) => {
  const utcDate = new Date(isoString);
  const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const zonedDate = utcToZonedTime(utcDate, localTimeZone);

  // Format as 1/28/2026, 22:00:01
  return format(zonedDate, 'M/d/yyyy, HH:mm:ss');
};

const DateTimeCell = (
  properties: CustomCellRendererProps<ServerDashboardJob>
) => {
  const dateValue = properties.value;

  if (!dateValue) {
    return null;
  }

  try {
    return <span>{convertTimeHumanReadable(dateValue)}</span>;
  } catch {
    return <span>{dateValue}</span>;
  }
};

export default DateTimeCell;
